import React from "react";
import { Container } from 'react-bootstrap';

import WOW from "wowjs";

class Hero extends React.Component {

	componentDidMount() {
    	new WOW.WOW().init();
  	}
  	render() {
		return (
			<div className="HereoBanner ADAcomplice">
			    <div className="Banner_Content">
					<Container fluid>
						<h2 className="pagehead-title wow fadeInUp">ADA Compliance Services</h2>
						<div className="red-border"> </div>
						<p>ADA- The Americans with Disabilities Act</p>
					</Container>
				</div>
			</div>
		);
	}
};

export default Hero;
